import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Trash2, Settings } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';

export function AdminCoursesTab({ courses, onCreateClick, onDelete }) {
  const navigate = useNavigate();
  return (
    <>
      <div className='mb-6 flex justify-between items-center'>
        <h2 className='text-2xl font-bold text-[#1A3C34]' style={{ fontFamily: 'Clash Display' }}>Manage Courses</h2>
        <Button data-testid='create-course-btn' onClick={onCreateClick} className='bg-[#D4F246] text-[#1A3C34] hover:bg-[#E2F585] rounded-full'>
          <Plus className='w-4 h-4 mr-2' /> Add Course
        </Button>
      </div>
      <div className='grid md:grid-cols-2 gap-6'>
        {courses.map((course, index) => (
          <Card key={course.id} className='p-6 bg-white rounded-2xl' data-testid={`course-card-${index}`}>
            <div className='flex justify-between items-start mb-4'>
              <div className='flex-1'>
                <div className='text-xs text-gray-500 mb-1'>{course.category}</div>
                <h3 className='text-xl font-bold text-[#1A3C34]'>{course.title}</h3>
              </div>
              <div className='flex items-center gap-2'>
                <span className='bg-[#D4F246] text-[#1A3C34] px-3 py-1 rounded-full text-xs font-bold'>R{course.price}</span>
                <Button 
                  size='sm' variant='outline' 
                  onClick={() => onDelete(course.id)} 
                  data-testid={`delete-course-${index}`}
                  className='text-red-600 hover:text-red-700 hover:bg-red-50'
                >
                  <Trash2 className='w-4 h-4' />
                </Button>
              </div>
            </div>
            <p className='text-gray-600 text-sm mb-4'>{course.description}</p>
            <div className='flex justify-between items-center'>
              <div className='flex gap-4 text-sm text-gray-600'>
                <span>{course.exercise_ids?.length || 0} exercises</span>
                <span>{course.duration_weeks} weeks</span>
                <span className='capitalize'>{course.difficulty}</span>
              </div>
              <Button 
                data-testid={`manage-course-${index}`}
                onClick={() => navigate(`/admin/courses/${course.id}`)}
                className='bg-[#1A3C34] text-white hover:bg-[#0F1115] rounded-full'
                size='sm'
              >
                <Settings className='w-3.5 h-3.5 mr-1.5' /> Manage
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
